export interface IBasic {
    id: number;
    name: string;
    enabled?:boolean;
}
